import { RouteType } from '../config';

import Dashboard from '../../pages/dashboard/Dashboard';
import Vendedores from '../../pages/vendedores/vendedores';
import Produtos from '../../pages/produtos/Produtos';
import Categorias from '../../pages/categorias/Categorias';
import Imposto from '../../pages/impostos/Imposto';
import Kanban from '../../pages/kanban/Kanban';
import Negociacao from '../../pages/negociacao/Negociacao';
import Orcamento from '../../pages/orcamento/Orcamento';
import Cliente from '../../pages/clientes/Cliente';
import TableLog from '../../pages/tableLog/TableLog';
import Logout from '../../pages/logout/Logout';
import Cores from '../../pages/cores/Cores';
import React from 'react';
import PainelVendedor from '../../pages/painelVendedor/PainelVendedor';
import FormasPagamento from '../../pages/formasPagamento/formasPagamento';
import BasicDocument from '../../components/PDF/PdfReview';

const appRoutes: RouteType[] = [
  {
    index: true,
    element: <Dashboard />,
    state: 'admin',
  },
  {
    path: '/admin/painelVendedor',
    element: <PainelVendedor />,
    state: 'painel',
    sidebarProps: {
      displayText: 'Painel vendedor',
    },
  },
  {
    path: '/admin/dashboard',
    element: <Dashboard />,
    state: 'dashboard',
    sidebarProps: {
      displayText: 'Dashboard',
    },
  },
  {
    path: '/admin/orcamento',
    element: <Orcamento />,
    state: 'admin',
    sidebarProps: {
      displayText: 'Orçamentos',
    },
  },
  {
    path: '/admin/vendedores',
    element: <Vendedores />,
    state: 'vendedores',
    sidebarProps: {
      displayText: 'Vendedores',
    },
  },
  {
    path: '/admin/pdf',
    element: <BasicDocument />,
    state: 'basicdocument',
    sidebarProps: {
      displayText: 'PDF',
    },
  },
  {
    path: '/admin/produtos',
    element: <Produtos />,
    state: 'produtos',
    sidebarProps: {
      displayText: 'Produtos',
    },
  },
  {
    path: '/admin/categorias',
    element: <Categorias />,
    state: 'categorias',
    sidebarProps: {
      displayText: 'Categorias',
    },
  },
  {
    path: '/admin/cores',
    element: <Cores />,
    state: 'cores',
    sidebarProps: {
      displayText: 'Cores',
    },
  },
  {
    path: '/admin/Impostos',
    element: <Imposto />,
    state: 'impostos',
    sidebarProps: {
      displayText: 'Impostos',
    },
  },
  {
    path: '/admin/kanban',
    element: <Kanban />,
    state: 'kanban',
    sidebarProps: {
      displayText: 'Kanban',
    },
  },
  {
    path: '/admin/clientes',
    element: <Cliente />,
    state: 'clientes',
    sidebarProps: {
      displayText: 'Clientes',
    },
  },
  {
    path: '/admin/formaPagamento',
    element: <FormasPagamento />,
    state: 'formaPagamento',
    sidebarProps: {
      displayText: 'Formas de Pagamento',
    },
  },
  {
    path: '/admin/negociacao',
    element: <Negociacao />,
    state: 'negociacao',
    sidebarProps: {
      displayText: 'Condições de negociação',
    },
  },
  {
    path: '/admin/log',
    element: <TableLog />,
    state: 'log',
    sidebarProps: {
      displayText: 'Registros de logs',
    },
  },
  {
    path: '/admin/sair',
    element: <Logout />,
    state: 'sair',
    sidebarProps: {
      displayText: 'Sair',
    },
  },
];

export default appRoutes;
